import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './core/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@app/layout/layout.module';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AcceptLanguageInterceptor} from '@app/shared/interceptors/accept-language.interceptor';
import {CookieConsentModule} from 'src/cookie-consent/cookie-consent.module';
import {CsrfInitializerService} from '@app/services/csrf-initializer.service';
import {Observable} from 'rxjs';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		CoreModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		LayoutModule,
		CookieConsentModule
	],
	providers: [
		{provide: HTTP_INTERCEPTORS, useClass: AcceptLanguageInterceptor, multi: true},
		{
			// Ensures that a CSRF token cookie is obtained from the backend on application startup.
			// Without a CSRF token up-front, the first request to an endpoint
			// that requires CSRF protection (e.g. login) will fail.
			provide: APP_INITIALIZER,
			useFactory: initializeCsrf,
			deps: [CsrfInitializerService],
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}

function initializeCsrf(svc: CsrfInitializerService): () => Observable<void> {
	return () => svc.initializeCsrf();
}
